export const coalesceSameRoleTurns = (msgs) => {
  if (!msgs || msgs.length === 0) return [];
  const out = [];
  let prev = null;
  for (const m of msgs) {
    const role = m.role === 'agent' ? 'assistant' : m.role;
    if (prev && prev.role === role && role !== 'tool') {
      prev.content = [prev.content, m.content].filter(Boolean).join(' ');
      if (m.timestamp && !prev.timestamp) prev.timestamp = m.timestamp;
    } else {
      prev = { ...m, role };
      out.push(prev);
    }
  }
  return out;
};

export const isPostCallTranscriptMessage = (message) => (
  message?.metadata?.source === 'post_call_recording_transcript'
);

export const getPostCallTranscriptMessages = (messages) => (
  (messages || []).filter(isPostCallTranscriptMessage)
);

// B0: turns stored during the call (caller and AI speech from Live
// transcription, plus tool results), in the order they happened.
const LIVE_TURN_SOURCES = new Set(['live_input_transcription', 'live_output_transcription', 'tool_call_result']);

export const getLiveTurnMessages = (messages) => (
  (messages || [])
    .filter((message) => LIVE_TURN_SOURCES.has(message?.metadata?.source))
    .map((message) => ({ ...message, role: message.role === 'agent' ? 'assistant' : message.role }))
);
